"use client"

import React, { useState } from "react"
import { fabric } from "fabric"
import __ from "./../utils/translation"

import InputAmount from "./InputAmount"
import { ChromePicker } from "react-color"

import { pathConfig } from "./../utils/pathConfig"

type Props = {
    canvas: fabric.Canvas | null
    onChange?: (settings: LineSettingsType) => void
}

type LineSettingsType = {
    strokeWidth: number
    stroke: string
}

const PathSettings = ({ canvas, onChange }: Props) => {
    const [lineSettings, setLineSettings] = useState<LineSettingsType>({
        strokeWidth: 2,
        stroke: "rgba(0,0,0,1)",
    })

    /* =========================
       UPDATE STROKE WIDTH
    ========================== */
    const handleStrokeWidthChange = (action: string, amount?: number) => {
        let width = lineSettings.strokeWidth

        if (action === "decrease") width = Math.max(1, width - 1)
        if (action === "increase") width++
        /*  if (action === "change") {
            width = parseInt(amount)
            if (!Number.isInteger(width)) return
          }*/

        setLineSettings({ ...lineSettings, strokeWidth: width })
        pathConfig.strokeWidth = width
    }

    /* =========================
       UPDATE STROKE COLOR
    ========================== */
    const handleStrokeColorChange = (color: any) => {
        const stroke = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`

        setLineSettings({ ...lineSettings, stroke })
        pathConfig.stroke = stroke
    }

    return (
        <>
            <p className="mt-2 mb-5 text-justify">
                Para iniciar caminho, clique no canvas e arraste o mouse para a direção desejada, clique novamente para ir criando caminhos. Para finalizar, aperte a tecla ESC no teclado.
            </p>

            <div className="setting">
                <div className="label lang" data-en="Line width" data-pt="Espessura da linha" data-es="Grosor de línea">
                    {__("Line width")}
                </div>
                <div className="function">
                    <InputAmount
                        className="bg-background text-black"
                        unit=""
                        value={lineSettings.strokeWidth}
                        handleDecrease={() => handleStrokeWidthChange("decrease", 1)}
                        handleChange={(e: any) =>
                            handleStrokeWidthChange("change", e.target.value)
                        }
                        handleIncrease={() => handleStrokeWidthChange("increase", 1)}
                    />
                </div>
            </div>

            <div className="setting">
                <div className="label lang" data-en="Line color" data-pt="Cor da linha" data-es="Color de línea">
                    {__("Line color")}
                </div>
                <div className="function"></div>
            </div>

            <ChromePicker
                color={lineSettings.stroke}
                onChange={handleStrokeColorChange}
            />
        </>
    )
}

export default PathSettings
